import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import type { SaveWaterMarketFeesRequest, WaterMarketFee } from '@models/water-market-fees';
import { Observable } from 'rxjs';

/**
 * Lake-level per-market fees (CS-287). The full set of markets is exchanged as one document: a GET
 * returns every market (missing ones filled with defaults) and a PUT replaces the set (the API stores
 * only markets that carry a real fee).
 */
@Injectable({ providedIn: 'root' })
export class CrmWaterMarketFeesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api/crm/waters`;

  getFees(waterId: number): Observable<WaterMarketFee[]> {
    return this.http.get<WaterMarketFee[]>(`${this.baseUrl}/${waterId}/market-fees`);
  }

  saveFees(waterId: number, request: SaveWaterMarketFeesRequest): Observable<WaterMarketFee[]> {
    return this.http.put<WaterMarketFee[]>(`${this.baseUrl}/${waterId}/market-fees`, request);
  }
}
